import React, { forwardRef, useState } from 'react';
import { Button, GlobalLoading } from '@/shared/components';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { useMutationDeleteFav } from '@/hooks/favorites.hook';
import { usePriceStore } from '../../../store/price-store';
import { SpinnerBox } from '@/shared/pageComponents/spinner-box';
import { useRouter } from 'next/navigation';
import { usePlacement, useProductClickEventTracking } from '@/shared/tracking/use-tracking-helpers';
import { useEventTracking } from '@/shared/tracking/use-tracking';
import { getProductPrice } from '@/shared/tracking/utils';
import { isEmpty } from 'lodash';
import { scrollToTop } from '@/app/utils';
import { buildPdpLink } from '@/app/utils/build-pdp-link';
interface IProps {
  product: any;
  removeFunc: any;
  setAddCartFailMessage: (failList) => void;
  index: number;
}
const ListTitle = forwardRef<HTMLInputElement, IProps>(function ListTitle(props, ref) {
  const { product, removeFunc, setAddCartFailMessage, index } = props;
  const [addCartLoading, setAddCartLoading] = useState(false);
  const { t } = useLang(NAMESPACE.favorites);
  const { t: commonT } = useLang(NAMESPACE.common);
  const { productPrice } = usePriceStore();
  const price = productPrice?.[product.catalogNumber];
  const { mutateAsync } = useMutationDeleteFav();
  const router = useRouter();

  const { trackEvent } = useEventTracking();
  const placement = usePlacement();

  const inValidItem =
    product?.warningMessageStatus === 'DISCONTINUED' ||
    product?.warningMessageStatus === 'BLOCKED' ||
    product?.dwgDepletedStockFlag;

  const onRemoveProduct = () => {
    GlobalLoading.show();
    mutateAsync([product.catalogNumber]).then((res: any) => {
      removeFunc();
      // removeFromFavoritesList tracking
      trackEvent({
        key: 'eventsData',
        action: 'removeFromFavoritesList',
        payload: {
          event_name: 'removeFromFavoritesList',
          contentType: 'Product',
          products: [
            {
              catalogId: product.catalogNumber,
              placement,
            },
          ],
        },
      });
    });
  };
  const onAddCart = async () => {
    setAddCartLoading(true);
    const res = await window.miniCart?.addProductsToCart([{ catalogNumber: product.catalogNumber, quantity: 1 }]);
    // add to cart tracking
    trackEvent({
      key: 'cart',
      action: 'addToCart',
      payload: {
        products: [
          {
            name: product?.catalogName,
            catalogId: product?.catalogNumber,
            quantity: 1,
            price: getProductPrice(price),
            uom: product?.unitSize,
            placement,
            method: 'favorites commerce-box',
          },
        ],
      },
    });
    setAddCartFailMessage(res?.data?.failWithMessage);
    setAddCartLoading(false);
    if (!isEmpty(res?.data?.failWithMessage)) {
      scrollToTop();
    }
  };

  const productClickTracking = useProductClickEventTracking();

  const onRouteToProductDetail = () => {
    productClickTracking(product, index);
    router.push(buildPdpLink(product.catalogNumber));
  };

  return (
    <div className="py-4">
      <div className="flex flex-col">
        <span
          dangerouslySetInnerHTML={{ __html: product.brandName ?? 'Thermo Scientific&trade;' }}
          className="text-xs font-normal text-gray-900"
        ></span>
        <Button
          type="link"
          onClick={onRouteToProductDetail}
          className="p-0 mt-[6px] text-left flex items-center h-auto cursor-pointer disabled:cursor-not-allowed disabled:bg-transparent disabled:border-none disabled:text-[#A5A5AE]"
          disabled={product.productStatus === 'DISCONTINUED'}
        >
          <span
            className="leading-none text-base font-bold"
            dangerouslySetInnerHTML={{ __html: product.catalogName }}
          ></span>
        </Button>
      </div>
      <div className="flex gap-x-6 items-center mt-4 print:hidden col-start-3 row-start-2 lg:row-start-3 sm:row-start-5 md:row-start-3 sm:col-start-2 sm:col-span-2 sm:justify-between">
        <Button
          type="link"
          className="p-0 text-left flex items-center h-auto leading-none relative"
          onClick={onRemoveProduct}
        >
          <i className="icon-24-bin-mono" />
          <span className="ml-[6px]">{t('delete')}</span>
        </Button>
        {price && price.priceStatus === 'Orderable' && !inValidItem && (
          <SpinnerBox isLoading={addCartLoading}>
            <Button
              type="link"
              className="p-0 text-left flex items-center h-auto leading-none px-2"
              onClick={onAddCart}
            >
              <i className="icon-24-cart-default-mono" />
              <span className="ml-[6px]">{commonT('add.to.cart')}</span>
            </Button>
          </SpinnerBox>
        )}
      </div>
    </div>
  );
});
export { ListTitle };
